import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
  * @module popover
  * @description A module to help with opening/closing popovers
  *
  * Note. There can be multiple popovers appearing on the screen at the same time.<br>
  * To achieve this, please use openId(..) instead of open()
  */
import React from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import Draggable from 'react-draggable';
import _ from 'lodash';
var handles = {};
var GLOBAL_POPOVER_ID = 'g-popover';

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false,
      position: {},
      display: null,
      cfg: {}
    });

    _defineProperty(_assertThisInitialized(_this), "setDragBounds", function () {
      var boundBy = _this.state.cfg.boundBy;
      var node = _this.node;

      var _boundBy$getBoundingC = boundBy.getBoundingClientRect(),
          boundLeft = _boundBy$getBoundingC.left,
          boundRight = _boundBy$getBoundingC.right,
          boundTop = _boundBy$getBoundingC.top,
          boundBottom = _boundBy$getBoundingC.bottom;

      var _node$getBoundingClie = node.getBoundingClientRect(),
          popLeft = _node$getBoundingClie.left,
          popRight = _node$getBoundingClie.right,
          popTop = _node$getBoundingClie.top,
          popBottom = _node$getBoundingClie.bottom;

      var _dragBounds = {
        left: boundLeft - popLeft,
        right: boundRight - popRight,
        top: boundTop - popTop,
        bottom: boundBottom - popBottom
      };

      _this.setState({
        _dragBounds: _dragBounds
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      if (_this.isOpen()) {
        _this.setState({
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isOpen", function () {
      return _this.state.open;
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (position, display) {
      var cfg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (_this.isOpen() && !cfg.updateOnly) {
        // close and re-open, so previous styles (including those calculated by browser)
        // are properly erased
        _this.setState({
          open: false
        }, function () {
          _this.open(position, display, cfg);
        });
      } else {
        _this.setState({
          _actualPosition: null,
          _dragBounds: null,
          position: position,
          display: display,
          cfg: cfg,
          open: true
        }, function () {
          // snap to bounds after initial display
          // so it can retrieve dom width/height
          _this.snapToBounds();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "snapToBounds", function () {
      var _this$state = _this.state,
          position = _this$state.position,
          _this$state$cfg = _this$state.cfg,
          draggable = _this$state$cfg.draggable,
          boundBy = _this$state$cfg.boundBy;
      var node = _this.node;
      var x = position.x,
          y = position.y,
          left = position.left,
          right = position.right,
          top = position.top,
          bottom = position.bottom;

      var _node$getBoundingClie2 = node.getBoundingClientRect(),
          popWidth = _node$getBoundingClie2.width,
          popHeight = _node$getBoundingClie2.height;

      var _boundBy$getBoundingC2 = boundBy.getBoundingClientRect(),
          boundLeft = _boundBy$getBoundingC2.left,
          boundRight = _boundBy$getBoundingC2.right,
          boundTop = _boundBy$getBoundingC2.top,
          boundWidth = _boundBy$getBoundingC2.width,
          boundBottom = _boundBy$getBoundingC2.bottom;

      var _actualPosition = {};
      var defaultX = left != null && right != null ? (left + right) / 2 : x;
      _actualPosition.left = defaultX;

      if (defaultX + popWidth > boundRight) {
        if (popWidth >= boundWidth) {
          _actualPosition.left = boundLeft;
          _actualPosition.maxWidth = boundWidth;
        } else {
          _actualPosition.left = boundRight - popWidth;
        }
      }

      var aroundTop = top == null ? y : top;
      var aroundBottom = bottom == null ? y : bottom;
      _actualPosition.top = aroundBottom;

      if (aroundBottom + popHeight > boundBottom) {
        // pick above or below, whichever having more vertical space
        var aboveSpace = aroundTop - boundTop;
        var belowSpace = boundBottom - aroundBottom;

        if (aboveSpace > belowSpace) {
          _actualPosition.top = aroundTop - popHeight;
          _actualPosition.maxHeight = Math.min(aboveSpace, popHeight);
        } else {
          _actualPosition.maxHeight = belowSpace;
        }
      }
      /*        if (pointy) {
                  _actualPosition.top += 6
              }*/


      _this.setState({
        _actualPosition: _actualPosition
      }, function () {
        draggable && _this.setDragBounds();
      });
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          _actualPosition = _this$state2._actualPosition,
          display = _this$state2.display,
          _dragBounds = _this$state2._dragBounds,
          _this$state2$cfg = _this$state2.cfg,
          draggable = _this$state2$cfg.draggable,
          style = _this$state2$cfg.style,
          className = _this$state2$cfg.className,
          open = _this$state2.open;

      if (!open) {
        return null;
      } else {
        var popoverContent = /*#__PURE__*/React.createElement("div", {
          ref: function ref(_ref) {
            _this2.node = _ref;
          },
          className: cx('c-popover pure-form', {
            /*pointy, */
            handle: draggable
          }, className),
          style: _objectSpread(_objectSpread({}, style), _actualPosition)
        }, display);
        return draggable ? /*#__PURE__*/React.createElement(Draggable, {
          handle: ".handle",
          bounds: _dragBounds
        }, popoverContent) : popoverContent;
      }
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "propTypes", {});

function callbackOpen(id, pos, display, cfg) {
  handles[id].open(!pos || !pos.target ? pos : _.pick(pos.target.getBoundingClientRect(), ['x', 'y', 'left', 'right', 'top', 'bottom']), display, _.defaults(cfg || {}, {
    draggable: false,
    boundBy: document.body,
    pointy: false,
    style: {},
    className: ''
  }));
}

export default {
  /**
   * Open global popover<br>
   * Uses openId, with id='g-popover'. See [openId()]{@link module:popover.openId}
   *
   * @param {object} position - open popover at this position (or around a box to avoid overlaying on the box)
   * @param {number} position.x - x position to open popover at
   * @param {number} position.y - y position to open popover at
   * @param {number} position.left - left bound to open popover around
   * @param {number} position.right - right bound to open popover around
   * @param {number} position.top - top bound to open popover around
   * @param {number} position.bottom - bottom bound to open popover around
   * @param {renderable} display - What to display in popover?
   * @param {object} cfg - display config
   * @param {boolean} [cfg.draggable=false] - Allow to drag popover?
   * @param {HTMLElement} [cfg.boundBy=document.body] - Bound the popover to specific region, this will force reposition of the popover
   * @param {boolean} [cfg.pointy=false] - disabled for now
   * @param {object} [cfg.style={}] - style to deploy to the popover
   * @param {string} [cfg.className=''] - className for the popover
   *
   */
  open: function open(pos, display, cfg) {
    this.openId(GLOBAL_POPOVER_ID, pos, display, cfg);
  },

  /**
   * Open popover with a given id, id will be the handler key
   * @param {string} id - popover handler id
   * @param {object} position - open popover at this position (or around a box to avoid overlaying on the box)
   * @param {number} position.x - x position to open popover at
   * @param {number} position.y - y position to open popover at
   * @param {number} position.left - left bound to open popover around
   * @param {number} position.right - right bound to open popover around
   * @param {number} position.top - top bound to open popover around
   * @param {number} position.bottom - bottom bound to open popover around
   * @param {renderable} display - What to display in popover?
   * @param {object} cfg - display config
   * @param {boolean} [cfg.draggable=false] - Allow to drag popover?
   * @param {HTMLElement} [cfg.boundBy=document.body] - Bound the popover to specific region, this will force reposition of the popover
   * @param {boolean} [cfg.pointy=false] - disabled for now
   * @param {object} [cfg.style={}] - style to deploy to the popover
   * @param {string} [cfg.className=''] - className for the popover
   *
   * @example
   *
  import {Popover} from 'react-ui'
  Popover.openId(
  'my-popover-id',
  {x:15,y:15},
  <img src='...' style={{maxWidth:100,maxHeight:100}}/>,
  {boundBy:document.body, draggable:false}
  )
     */
  openId: function openId(id, pos, display, cfg) {
    if (!id) console.error('openId:missing id');else if (handles[id]) callbackOpen(id, pos, display, cfg);else {
      var node = document.createElement('DIV');
      node.id = id;
      document.querySelectorAll("*[id=\"".concat(id, "']")).forEach(function (el) {
        return el.remove();
      });
      document.body.appendChild(node);
      ReactDOM.render( /*#__PURE__*/React.createElement(Popover, {
        ref: function ref(el) {
          handles[id] = el;
          callbackOpen(id, pos, display, cfg);
        }
      }), document.getElementById(id));
    }
  },

  /**
   * Close popover
   *
   * @example
  Popover.close();
   */
  close: function close() {
    this.closeId(GLOBAL_POPOVER_ID);
  },

  /**
   * Close popover for given id
   * @param {string} id - close popover for this id
   *
   * @example
  Popover.closeId('my-popover-id');
   */
  closeId: function closeId(id) {
    handles[id] && handles[id].close();
  }
};